import { Link } from 'react-router-dom';
import { Button } from 'src/modules/common/components/Button/Button';
import { I18n } from 'src/modules/common/components/I18n/I18n';
import { MESSAGES } from 'src/modules/common/constants';
import { ArrowRightIcon } from 'src/modules/common/icons/ArrowRightIcon';
import { PATHS } from 'src/sensors/common/types/Paths';
import { LocationState } from 'src/sensors/LocationState';

type Props = {
    label: string;
    locationState: LocationState;
    currentPage: number;
    searchParams: URLSearchParams;
}

export const SensorsSelectSensorButton = ({ label, locationState, currentPage, searchParams }: Props) => (
    <Button
        as={Link}
        className="vss-sensors-select-sensor-button"
        to={{
            pathname: [
                PATHS.Accessories,
                encodeURIComponent(label),
                '1',
            ].join('/'),
            search: searchParams.toString(),
        }}
        state={{
            ...locationState,
            sensorLabel: label,
            sensorsPage: currentPage.toString(),
            selectedAccessories: [],
            sent: false,
            qty: 1,
        }}
        icon={(
            <div className="vss-sensors-select-sensor-button__icon">
                <ArrowRightIcon/>
            </div>
        )}
    >
        <I18n messageId={MESSAGES.selectDevice}/>
    </Button>
);
